/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmDenikSslStrediskoSpisovychUzlu extends GContentBase<SeznamAdmDenikSslStrediskoSpisovychUzluObj> {
        private seznamObj: SeznamAdmDenikSslStrediskoSpisovychUzluObj & GContent;
        private nazev: string;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmDenikSslStrediskoSpisovychUzluObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmDenikSslStrediskoSpisovychUzlu",
                contentCaption: "jres:33000624".format(this.nazev), //RC 33000624 : {0} navázané na deník
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{sslden} - {ixs_tre_txt}"
                },
                gridSettings: {
                    columnOrder: "sslden,ixs_tre_txt,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmDenikSslStrediskoSpisovychUzluObj extends GAdmSeznamBase {
        sslden: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmDenikSslStrediskoSpisovychUzlu", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmDenikSslStrediskoSpisovychUzlu",
                newRecord: isNew,
                sslden: isNew == true ? ((this.sslden) ? this.sslden : null) : data.sslden,
                ixs_tre: isNew == true ? null : data.ixs_tre,
                subrada: isNew == true ? null : data.subrada
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:29808057").addField("gselectbox", Gordic.Prefabs.Select.sslsden(), {
                name: "sslden",
                model: "model.sslden=value.sslden",
                dropdown: true,
                disabled: (this.sslden) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.sslden) 
                hardFilter["sslden"] = this.sslden
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any, poradi_new?: number) {
            this.cnt.isl.AdmDenikSslStrediskoSpisovychUzlu.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}".format(data.ixs_tre, data.sslden, data.subrada),
                nazev: "{0} - {1}".format(data["ixs_tre_txt"], data["sslden"])
            }
        }
    }
}